import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { Label as Label$1, LabelWrapper } from '../A11YLabel/A11YLabel.js';
import { base } from '../Button/StyledButton.js';
import { IconArrowDown } from '../Icons/IconArrowDown.js';
import { getContainerStyles } from '../Input/InputContainer.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["renderLabel"];
var Button = styled.button.withConfig({
  displayName: "SelectButton__Button",
  componentId: "sc-1a5b4hm-0"
})(function (props) {
  var containerStyles = getContainerStyles(props);
  return {
    height: 32,
    "&&": _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, base), containerStyles), {}, {
      display: "inline-flex",
      fontWeight: "normal"
    }, props.active && !props.error ? {
      borderColor: props.theme.neutralColors.smoke
    } : {}), {}, {
      ":hover:enabled": {
        backgroundColor: containerStyles.background,
        color: containerStyles.color
      },
      ":focus, :active:enabled": {
        color: containerStyles.color,
        "border-color": containerStyles.borderColor
      },
      width: "100%"
    })
  };
});
var Label = styled(Label$1).withConfig({
  displayName: "SelectButton__Label",
  componentId: "sc-1a5b4hm-1"
})(["&&{flex:1;text-align:left;}"]);

function Component(props, ref) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var renderLabel = props.renderLabel,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({}, rest), {}, {
    focused: focused,
    onBlur: function onBlur() {
      return setFocused(false);
    },
    onFocus: function onFocus() {
      return setFocused(true);
    },
    tabIndex: props.disabled ? -1 : rest.tabIndex,
    type: "button",
    ref: ref,
    children: /*#__PURE__*/jsxs(LabelWrapper, {
      children: [/*#__PURE__*/jsx(Label, {
        pushRight: true,
        children: renderLabel()
      }), /*#__PURE__*/jsx(IconArrowDown, {
        size: 20
      })]
    })
  }));
}

Component.displayName = "SelectButton";
var SelectButton = /*#__PURE__*/React.forwardRef(Component);

export { SelectButton };
